var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"16px"}},[_c('div',{ref:"editor",staticStyle:{"width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }